import BudgetSection from "../Common/BudgetSection";
import { COLORS } from "../../../lib/appColors";

export default function Savings() {
  return (
    <BudgetSection
      itemType="savings"
      accentColor={COLORS.savings}
      addLabel="ADD SAVING"
      addPath="/budget/savings/new"
      emptyMessage='No savings yet. Click "Add Saving" to create your first entry.'
    />
  );
}
